<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">グルーピング選択</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div>
            <h1>会員生協</h1>
            <div class="block-row">
              <div class="column-list">
                <label class="list-input-title">い</label>
                <div class="list-input-content">
                  <select id="cmb_Coop142" #cmb_Coop142 labelField="displayValue" forcedEnabledMode="none" [tabindex]="0"
                    [(ngModel)]="this.kymw0F00Model.coop142">
                    <ng-template ngFor let-item [ngForOf]="this.kymw0F00Model.coopList142">
                      <option value="{{item.code}}">{{item.displayValue}}</option>
                    </ng-template>
                  </select>
                </div>
                <label class="list-input-title">さ</label>
                <div class="list-input-content">
                  <select id="cmb_Coop210" #cmb_Coop210 labelField="displayValue" forcedEnabledMode="none" [tabindex]="0"
                    [(ngModel)]="this.kymw0F00Model.coop210">
                    <ng-template ngFor let-item [ngForOf]="this.kymw0F00Model.coopList210">
                      <option value="{{item.code}}">{{item.displayValue}}</option>
                    </ng-template>
                  </select>
                </div>
              </div>
              <div class="column-list">
                <label class="list-input-title">と</label>
                <div class="list-input-content">
                  <select id="cmb_Coop163" #cmb_Coop163 labelField="displayValue" forcedEnabledMode="none" [tabindex]="0"
                    [(ngModel)]="this.kymw0F00Model.coop163">
                    <ng-template ngFor let-item [ngForOf]="this.kymw0F00Model.coopList163">
                      <option value="{{item.code}}">{{item.displayValue}}</option>
                    </ng-template>
                  </select>
                </div>
                <label class="list-input-title">とう</label>
                <div class="list-input-content">
                  <select id="cmb_Coop302" #cmb_Coop302 labelField="displayValue" forcedEnabledMode="none" [tabindex]="0"
                    [(ngModel)]="this.kymw0F00Model.coop302">
                    <ng-template ngFor let-item [ngForOf]="this.kymw0F00Model.coopList302">
                      <option value="{{item.code}}">{{item.displayValue}}</option>
                    </ng-template>
                  </select>
                </div>
              </div>
              <div class="column-list">
                <label class="list-input-title">ぐ</label>
                <div class="list-input-content">
                  <select id="cmb_Coop185" #cmb_Coop185 labelField="displayValue" forcedEnabledMode="none" [tabindex]="0"
                    [(ngModel)]="this.kymw0F00Model.coop185">
                    <ng-template ngFor let-item [ngForOf]="this.kymw0F00Model.coopList185">
                      <option value="{{item.code}}">{{item.displayValue}}</option>
                    </ng-template>
                  </select>
                </div>
                <label class="list-input-title">な</label>
                <div class="list-input-content">
                  <select id="cmb_Coop515" #cmb_Coop515 labelField="displayValue" forcedEnabledMode="none" [tabindex]="0"
                    [(ngModel)]="this.kymw0F00Model.coop515">
                    <ng-template ngFor let-item [ngForOf]="this.kymw0F00Model.coopList515">
                      <option value="{{item.code}}">{{item.displayValue}}</option>
                    </ng-template>
                  </select>
                </div>
              </div>
              <div class="column-list">
                <label class="list-input-title">ち</label>
                <div class="list-input-content">
                  <select id="cmb_Coop240" #cmb_Coop240 labelField="displayValue" forcedEnabledMode="none" [tabindex]="0"
                    [(ngModel)]="this.kymw0F00Model.coop240">
                    <ng-template ngFor let-item [ngForOf]="this.kymw0F00Model.coopList240">
                      <option value="{{item.code}}">{{item.displayValue}}</option>
                    </ng-template>
                  </select>
                </div>
                <label class="list-input-title">に</label>
                <div class="list-input-content">
                  <select id="cmb_Coop451" #cmb_Coop451 labelField="displayValue" forcedEnabledMode="none" [tabindex]="0"
                    [(ngModel)]="this.kymw0F00Model.coop451">
                    <ng-template ngFor let-item [ngForOf]="this.kymw0F00Model.coopList451">
                      <option value="{{item.code}}">{{item.displayValue}}</option>
                    </ng-template>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <button id="btn_Display" #btn_Display class="btn-secondary" forcedEnabledMode="true" [tabindex]="0"
            (click)="eventDisplay_CLICKHandler()">表示</button>
        </div>

        <div class="grid-container">
          <wj-flex-grid #dtg_GroupingInfoList id="dtg_GroupingInfoList"
            [itemsSource]="this.kymw0F00Model.groupingInfoList" forcedEnabledMode="true" [headersVisibility]="'Column'"
            [allowDragging]="'None'" [selectionMode]="'Row'" [tabindex]="0" [isReadOnly]="true">

            <wj-flex-grid-column [minWidth]="5" [width]="140" [header]="'グルーピングコード'" [binding]="'GroupingCode'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="240" [header]="'グルーピング名称'" [binding]="'GroupingName'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="60" [header]="'い'" [binding]="'GroupingDiv142'"
              [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="60" [header]="'と'" [binding]="'GroupingDiv163'"
              [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="60" [header]="'ぐ'" [binding]="'GroupingDiv185'"
              [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="60" [header]="'ち'" [binding]="'GroupingDiv240'"
              [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="60" [header]="'さ'" [binding]="'GroupingDiv210'"
              [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="60" [header]="'とう'" [binding]="'GroupingDiv302'"
              [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="60" [header]="'な'" [binding]="'GroupingDiv515'"
              [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="60" [header]="'に'" [binding]="'GroupingDiv451'"
              [align]="'center'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="290" [header]="'備考'"
              [binding]="'Remarks'"></wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_SetData" [tabindex]="0" class="btn-primary" (click)="eventSet_CLICKHandler()">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>